import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function OfferSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="offer-section" className="w-full py-24 px-6 relative overflow-hidden" style={{
    background: '#111827'
  }} data-id="element-158">
      {/* Warm glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,168,83,0.1) 0%, transparent 70%)'
    }} data-id="element-159" />

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-160">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-161">
          <div className="amber-divider mb-8" data-id="element-162" />

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-163">
            Reprenez enfin le contrôle de vos nuits
          </h2>

          {/* Price block */}
          <div className="inline-flex flex-col items-center rounded-2xl px-10 py-8 mb-10" style={{
          background: 'rgba(212,168,83,0.08)',
          border: '1px solid rgba(212,168,83,0.3)'
        }} data-id="element-164">
            <span className="text-xs uppercase tracking-widest mb-3 px-3 py-1 rounded-full" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#0D1B2A',
            background: '#D4A853',
            fontWeight: 600
          }} data-id="element-165">
              Offre de lancement limitée
            </span>

            {/* New price */}
            <div className="flex items-end gap-2" data-id="element-166">
              <span className="text-7xl md:text-8xl font-bold leading-none" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-167">
                9.97
              </span>
              <span className="text-3xl font-bold mb-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-168">
                $
              </span>
            </div>

            <p className="text-sm mt-2" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-169">
              Accès immédiat · Livraison par email
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col items-center gap-4" data-id="element-170">
            <a href="https://redevenirmoi.com/cart/53294357643632:1" className="cta-pulse w-full max-w-lg inline-flex items-center justify-center gap-2 px-8 py-5 rounded-xl text-base md:text-lg font-semibold transition-transform hover:scale-105 active:scale-95" style={{
            background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
            color: '#0D1B2A',
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 700,
            textDecoration: 'none'
          }} data-id="element-171">
              👉 OUI, JE VEUX ÉTEINDRE MON CERVEAU ET DORMIR
            </a>

            <p className="text-sm" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-172">
              🔒 Paiement sécurisé · Accès immédiat par email
            </p>

            <div className="flex flex-wrap justify-center gap-4 mt-2 text-xs" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-173">
              <span data-id="element-174">✓ Livraison numérique instantanée</span>
              <span data-id="element-175">✓ Compatible mobile & tablette</span>
              <span data-id="element-176">✓ Aucun abonnement</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}